import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { Chip } from '@mui/material'
import { CircleAlertIcon, CircleCheckIcon } from 'lucide-react'

type Status = 'FECHADA' | 'ABERTA'

export function StatusCompetencia({ row }: GridCellParams) {
    const status = row.status as Status

    const renderStatus = () => {
        switch (status) {
            case 'FECHADA':
                return (
                    <Chip
                        label="Fechada"
                        color="success"
                        icon={<CircleCheckIcon />}
                    />
                )
            case 'ABERTA':
                return (
                    <Chip
                        label="Aberta"
                        color="info"
                        icon={<CircleAlertIcon />}
                    />
                )
        }
    }

    return renderStatus()
}
